import { Link } from "react-router-dom";
import { categories, topics } from "@/mocks/news";

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100 mt-16">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-xl">
                <i className="ri-flashlight-fill" />
              </span>
              <span className="text-xl font-heading font-black">51爆料</span>
            </div>
            <p className="text-sm text-background-200/80 leading-relaxed">
              聚焦社会、娱乐、科技多领域的热点新闻与内幕爆料，为每一个关心真相的人提供及时、多元的资讯视角。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a
                href="#"
                rel="nofollow"
                aria-label="微信"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors cursor-pointer"
              >
                <i className="ri-wechat-line text-lg" />
              </a>
              <a
                href="#"
                rel="nofollow"
                aria-label="微博"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors cursor-pointer"
              >
                <i className="ri-weibo-line text-lg" />
              </a>
              <a
                href="#"
                rel="nofollow"
                aria-label="抖音"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors cursor-pointer"
              >
                <i className="ri-tiktok-line text-lg" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-base font-bold mb-4">爆料分类</h4>
            <ul className="space-y-2.5 text-sm">
              {categories.map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/category/${c.slug}`}
                    className="text-background-200/80 hover:text-background-50 cursor-pointer transition-colors"
                  >
                    {c.name}爆料
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-base font-bold mb-4">热门专题</h4>
            <ul className="space-y-2.5 text-sm">
              {topics.map((t) => (
                <li key={t.id}>
                  <Link
                    to={`/topic/${t.id}`}
                    className="text-background-200/80 hover:text-background-50 cursor-pointer transition-colors"
                  >
                    {t.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-base font-bold mb-4">关于与帮助</h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link
                  to="/about"
                  className="text-background-200/80 hover:text-background-50 cursor-pointer transition-colors"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-background-200/80 hover:text-background-50 cursor-pointer transition-colors"
                >
                  联系反馈
                </Link>
              </li>
              <li>
                <Link
                  to="/search"
                  className="text-background-200/80 hover:text-background-50 cursor-pointer transition-colors"
                >
                  站内搜索
                </Link>
              </li>
              <li className="text-background-200/70">
                邮箱：contact@51baoliao.com
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-50/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-200/70">
          <p>© 2026 51爆料 baoliao. 本站内容为演示资讯，仅供浏览参考。</p>
          <p className="flex items-center gap-4">
            <span>隐私声明</span>
            <span>内容规范</span>
            <span>版权合作</span>
          </p>
        </div>
      </div>
    </footer>
  );
}